"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LayerProperties {
}
exports.LayerProperties = LayerProperties;
class BodyExt extends Phaser.Physics.Arcade.Body {
}
exports.BodyExt = BodyExt;
